import { ITimetableSchedule } from 'src/api/getTimetable';
import { getScheduleTrack, TimetableEntityRef } from './helpers';
import { reassignToDefault, RemoveScheduleResult } from './reassignToDefault';

/**
 * Builds the PATCH payload for removing one schedule: its (day, track) lane is resent with the
 * removed slot handed to the timetable's default entity - see reassignToDefault.
 */
export const removeScheduleBlocks = (
  existingSchedules: ITimetableSchedule[],
  removedSchedule: ITimetableSchedule,
  defaultEntity: TimetableEntityRef,
): RemoveScheduleResult =>
  reassignToDefault(
    existingSchedules,
    getScheduleTrack(removedSchedule),
    (schedule) => schedule.schedule_id === removedSchedule.schedule_id,
    defaultEntity,
  );
